import request from "@/utils/request";

export default function remove(id) {
    return request({
        url: `/storeProduct/admin/remove/`+id,
        method: 'get',
    })
}
